export default "__VITE_ASSET__d65c0475__"